/**
 * Parse LD_Case_Counts_by_County_2023_updated.csv into rows keyed by 5-digit FIPS.
 */
export function caseColumnForYear(year) {
    if (year >= 2001 && year <= 2020) return `Cases${year}`;
    if (year === 2021) return 'cases2021';
    if (year === 2022) return 'cases2022';
    if (year === 2023) return 'cases2023';
    return null;
}

export function rowToFips(row) {
    const st = String(parseInt(row.stcode, 10)).padStart(2, '0');
    const cty = String(parseInt(row.ctycode, 10)).padStart(3, '0');
    return `${st}${cty}`;
}

/**
 * @returns {{ cases: number, hasData: boolean }}
 */
export function getCaseInfo(row, year) {
    const col = caseColumnForYear(year);
    if (!col || !row) {
        return { cases: 0, hasData: false };
    }
    const raw = row[col];
    if (raw == null || String(raw).trim() === '') {
        return { cases: 0, hasData: false };
    }
    const n = parseInt(String(raw).trim(), 10);
    if (!Number.isFinite(n)) {
        return { cases: 0, hasData: false };
    }
    return { cases: n, hasData: true };
}

/**
 * Minimal CSV parse (no embedded commas in fields for this file).
 */
export function parseLymeCsv(text) {
    const lines = text.trim().split(/\r?\n/);
    if (lines.length < 2) return new Map();

    const headers = lines[0].split(',').map((h) => h.trim());
    const byFips = new Map();

    for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        if (!line.trim()) continue;

        const parts = line.split(',');
        if (parts.length < headers.length) continue;

        const row = {};
        for (let j = 0; j < headers.length; j++) {
            row[headers[j]] = parts[j] != null ? String(parts[j]).trim() : '';
        }

        if (row.stcode === '' || row.ctycode === '') continue;

        const fips = rowToFips(row);
        byFips.set(fips, row);
    }

    return byFips;
}

export function getCaseCount(row, year) {
    return getCaseInfo(row, year).cases;
}
